'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  Root: function Root(_ref) {
    var _ref$children = _ref.children,
        children = _ref$children === undefined ? null : _ref$children;
    return _react2.default.createElement(
      'div',
      null,
      children
    );
  },
  Index: function Index(_ref2) {
    var _ref2$children = _ref2.children,
        children = _ref2$children === undefined ? null : _ref2$children;
    return _react2.default.createElement(
      'div',
      null,
      children
    );
  },
  Header: function Header(_ref3) {
    var _ref3$children = _ref3.children,
        children = _ref3$children === undefined ? null : _ref3$children;
    return _react2.default.createElement(
      'div',
      null,
      children
    );
  },
  HomeDetail: function HomeDetail(_ref4) {
    var _ref4$children = _ref4.children,
        children = _ref4$children === undefined ? null : _ref4$children;
    return _react2.default.createElement(
      'div',
      null,
      children
    );
  },
  HomesList: function HomesList(_ref5) {
    var _ref5$children = _ref5.children,
        children = _ref5$children === undefined ? null : _ref5$children;
    return _react2.default.createElement(
      'div',
      null,
      children
    );
  },
  CommunityDetail: function CommunityDetail(_ref6) {
    var _ref6$children = _ref6.children,
        children = _ref6$children === undefined ? null : _ref6$children;
    return _react2.default.createElement(
      'div',
      null,
      children
    );
  },
  CommunityDetailHomes: function CommunityDetailHomes(_ref7) {
    var _ref7$children = _ref7.children,
        children = _ref7$children === undefined ? null : _ref7$children;
    return _react2.default.createElement(
      'div',
      null,
      children
    );
  },
  CommunityDetailPlans: function CommunityDetailPlans(_ref8) {
    var _ref8$children = _ref8.children,
        children = _ref8$children === undefined ? null : _ref8$children;
    return _react2.default.createElement(
      'div',
      null,
      children
    );
  },
  CommunitiesList: function CommunitiesList(_ref9) {
    var _ref9$children = _ref9.children,
        children = _ref9$children === undefined ? null : _ref9$children;
    return _react2.default.createElement(
      'div',
      null,
      children
    );
  },
  PlanDetail: function PlanDetail(_ref10) {
    var _ref10$children = _ref10.children,
        children = _ref10$children === undefined ? null : _ref10$children;
    return _react2.default.createElement(
      'div',
      null,
      children
    );
  },
  PlansList: function PlansList(_ref11) {
    var _ref11$children = _ref11.children,
        children = _ref11$children === undefined ? null : _ref11$children;
    return _react2.default.createElement(
      'div',
      null,
      children
    );
  },
  BlogpostList: function BlogpostList(_ref12) {
    var _ref12$children = _ref12.children,
        children = _ref12$children === undefined ? null : _ref12$children;
    return _react2.default.createElement(
      'div',
      null,
      children
    );
  },
  BlogpostDetail: function BlogpostDetail(_ref13) {
    var _ref13$children = _ref13.children,
        children = _ref13$children === undefined ? null : _ref13$children;
    return _react2.default.createElement(
      'div',
      null,
      children
    );
  },
  NoRoute: function NoRoute(_ref14) {
    var _ref14$children = _ref14.children,
        children = _ref14$children === undefined ? null : _ref14$children;
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'p',
        null,
        '404 Page Not Found'
      ),
      children
    );
  }
}; /* eslint-disable react/prop-types */
exports.default = components;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-navigation-stacks/build/DefaultPageComponents.js
// module id = 207
// module chunks = 0